import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaContabilidad } from '../_contabilidad.js';

/**
 * El estado de resultados del mes y el consolidado, pantalla 6f.
 *
 * Vive dentro de `_contabilidad`, que ya exige `utilidad.ver` en nivel 3: es la única pantalla donde
 * aparece la utilidad, y el operario y el jefe de operarios no la tienen. No repite verificación.
 * El componente llega a pedido, como los hermanos, para que quien no entra aquí no lo descargue.
 */
export const rutaResultados = createRoute({
  getParentRoute: () => rutaContabilidad,
  path: '/resultados',
  component: lazyRouteComponent(
    () => import('../../funcionalidades/resultados/PaginaResultados.js'),
    'PaginaResultados'),
});
